import React from 'react'
import {graphql} from 'gatsby'
import {Asset} from '../../../../plugins/gatsby-plugin-atollon'

const LandingBanner = ({image, video}) => {

  return (
    <section className='landing-banner'>
      <div className='landing-banner__asset'>
        {video && <video className='landing-banner__video' poster={image?.url} src={video} autoPlay loop muted playsInline /> }
        {image && !video && <Asset className='landing-banner__bg' asset={image}/> }
      </div>
    </section>
  )
}

export default LandingBanner

export const query = graphql`
  fragment LandingBannerProps on DatoCmsLandingBanner {
    ... on DatoCmsLandingBanner {
      id
      image {
        ...InternalAssetProps
      }
      video
    }
  }
`;
